import React from "react"
import styled from "styled-components"

const Layout = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  background: linear-gradient(to right top, #EAEEF3, #FFFFFF);
  ${props => props.theme.media.smallDesktop`
    background: linear-gradient(0deg, #EAEEF3, #F7F9FB);
  `}
`

const CheckoutLayout = ({ children }) => {
  return (
    <Layout>
        {children}
    </Layout>
  )
}

export default CheckoutLayout
